<template>
  <header>
    <div class="c-banner-shopping" @click="userValidateToRedirect('shopping')">
      <div class="container">
        <div class="columns is-vcentered is-gapless">
          <div class="column is-5">
            <div class="c-banner-shopping__content">
              <!-- <p
                class="has-text-primarydark has-text-weight-bold margin-bottom"
              >
                NOVIDADE
              </p>
              <div class="columns is-mobile">
                <div class="column is-9-mobile">
                  <h1
                    class="c-banner-shopping__content-title is-size-4 is-size-2-desktop has-text-grey-darker has-text-weight-bold"
                  >
                    Shopping Casar.com com 4% de cashback
                  </h1>
                </div>

                <a
                  class="column is-3 is-hidden-tablet"
                  @click="userValidateToRedirect('shopping')"
                >
                  <base-icon
                    width="14px"
                    height="24px"
                    name="painel/chevron-left-icon"
                    class="has-text-primarydark"
                    style="margin-top: 1em; z-index: 8;"
                  />
                </a>
              </div>

              <p
                class="c-banner-shopping__content-text is-size-6 is-size-5-desktop has-text-grey-darker"
              >
                Você compra e recebe dinheiro de volta
              </p>
              <a
                @click="userValidateToRedirect('shopping')"
                :disabled="!walletSummary.owner_cpf"
                type="button"
                style="margin-right: 1em;"
                class="button is-primary is-big margin-bottom"
              >
                <base-icon
                  style="margin-right: .5em;"
                  width="24px"
                  height="24px"
                  name="painel/shopping-icon"
                />
                Acessar shopping
              </a>
              <a
                @click="learnMore"
                :href="moreAboutUrl"
                target="_blank"
                class="button is-big is-outlined is-black is-hidden-mobile"
                rel="noopener noreferrer"
                >Saiba mais</a
              > -->
            </div>
          </div>
          <div class="column">
            <div class="c-banner-shopping__picture is-hidden-mobile">
              <!-- <img :src="img.imgDesktop" :alt="img.name" /> -->
            </div>
            <div class="c-banner-shopping__picture is-hidden-tablet">
              <!-- <img :src="img.imgMobile" :alt="img.name" /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="c-banner-suppliers">
      <div class="column">
        <hooper class="is-hidden-tablet hooper" :settings="hooperSettings">
          <slide v-for="(supplier, index) in suppliers" :key="index">
            <div class="c-banner-suppliers__supplier">
              <a @click="userValidateToRedirect(supplier.url, 'suppliers')">
                <img :src="supplier.img" :alt="supplier.name" />
              </a>
            </div>
          </slide>
        </hooper>
        <div
          class="c-banner-suppliers__suppliers is-hidden-mobile columns is-vcentered is-centered"
        >
          <div
            class="column is-2"
            v-for="(supplier, index) in suppliers"
            :key="index"
          >
            <div class="c-banner-suppliers__supplier">
              <a
                @click="userValidateToRedirect(supplier.url, 'suppliers')"
                class="tooltip is-tooltip-multiline"
                :data-tooltip="
                  'Acessar loja ' + supplier.name + ' no Shopping Casar.com'
                "
              >
                <img :src="supplier.img" :alt="supplier.name" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { Hooper, Slide } from 'hooper'
import 'hooper/dist/hooper.css'

import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

import camicadoImg from '@/assets/img/camicado.png'
import pontoFrioImg from '@/assets/img/ponto-frio.png'
import casasBahiaImg from '@/assets/img/casas-bahia.png'
import extraImg from '@/assets/img/extra.png'
import fastShopImg from '@/assets/img/fast-shop.png'
import magaluImg from '@/assets/img/magalu.png'
import bannerImg from '@/assets/img/shopping-banner.png'
import bannerImgPromotional from '@/assets/img/banner-mobile_carteira_shopping_v1.jpg'
import bannerImgDesktopPromotional from '@/assets/img/banner-desktop_carteira_shopping_v1.jpg'

const SITE_URL = process.env.VUE_APP_SITE_URL

export default {
  mixins: [verifyDataUserMixin],

  components: {
    Hooper,
    Slide,
  },

  computed: {
    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    storeUrl() {
      return this.shoppingUrl + this.externalToken + this.shoppingReturnUrl
    },
  },

  data() {
    return {
      defaultPathShopping: 'shopping',
      suppliers: [
        { name: 'Camicado', img: camicadoImg, url: 'camicado' },
        { name: 'Ponto Frio', img: pontoFrioImg, url: 'pontofrio' },
        { name: 'Casas Bahia', img: casasBahiaImg, url: 'casasbahia' },
        { name: 'Extra', img: extraImg, url: 'extra' },
        { name: 'Fast Shop', img: fastShopImg, url: 'fastshop' },
        { name: 'Magalu', img: magaluImg, url: 'magazineluiza' },
      ],
      img: {
        imgMobile: bannerImg,
        name: 'Batedeira vermelha disponível para compra no Shopping Casar.com',
      },

      hooperSettings: {
        itemsToShow: 1.8,
      },

      moreAboutUrl: SITE_URL + 'shopping-casar-beta',
      bannerImgPromotional,
      bannerImgDesktopPromotional,
    }
  },

  methods: {
    userValidateToRedirect(params, redirectTypeName) {
      if (params == 'shopping') {
        this.$ga.event(
          'carteira',
          'click',
          'carteira-shopping-tela-intermediaria'
        )
      }

      if (this.verifyDataUser()) {
        this.goTo(params, redirectTypeName)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
    learnMore() {
      this.$ga.event('carteira', 'click', 'carteira-pix-tela-intermediaria')
    },
  },
}
</script>

<style lang="scss">
.c-banner-shopping {
  padding: 2.5em 0 1.5em;
  background-color: #fdf2f6;
  height: 500px;

  //PROMOTINAL STYLES
  @media (max-width: $mobile) {
    background-image: url('~@/assets/img/banner-mobile_carteira_shopping_v1.jpg');
    padding-top: 98% !important;
  }
  background-image: url('~@/assets/img/banner-desktop_carteira_shopping_v1.jpg');
  background-color: #fff;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 0 !important;
  padding-top: 16.64% !important;
  cursor: pointer;
  @media (min-width: $tablet) {
    padding: 3em;
    height: auto;
  }

  > container {
    @media (min-width: $tablet) {
      padding: 3em;
    }
  }

  &__content {
    padding: 0 1.5em 1em;

    @media (min-width: $desktop) {
      padding: 1em 1.5em 1em;
    }

    &-title {
      line-height: 1;
      margin-bottom: 0 !important;
      @media (min-width: $tablet) {
        margin-bottom: 8px;
      }
    }

    &-text {
      margin-top: 0;
      @media (min-width: $tablet) {
        margin-bottom: 1em;
      }
    }

    > a {
      z-index: 7;

      @media (max-width: $mobile) {
        display: flex;
        width: 100%;
        position: relative;
        top: 290px;
        bottom: 5px;
      }
    }

    > .columns {
      > .column {
        padding-bottom: 0 !important;
      }
    }
  }

  &__picture {
    position: relative;
    width: 100%;

    @media (min-width: $tablet) {
      width: 100%;
    }

    > img {
      @include position(absolute, 50%, 0, auto, auto, -18%);
      max-height: 300px;

      @media (min-width: $tablet) {
        @include position(absolute, 50%, 0, auto, 10%, -50%);
        max-height: 360px;
      }
    }
  }
}
.c-banner-suppliers {
  padding: 0.6em 0 0.5em;
  border-top: $gray-3 1px solid;
  border-bottom: $gray-3 1px solid;
  background-color: $white;

  @media (min-width: $tablet) {
    padding: 0.5em 3em 0.5em 3em;
    height: auto;
  }

  > .column {
    height: 80px;
    padding: 0;
    margin: 0;
  }

  &__suppliers {
    max-width: 90%;
    margin: 0 auto;
    @media (min-width: $tablet) {
      max-height: auto;
    }
    > .column {
      height: 80px;
      padding: 0;
      margin: 0;
    }
  }

  &__supplier {
    position: relative;
    width: 90%;
    height: 80px;
    border-radius: 8px;
    text-align: center;

    @media (min-width: $tablet) {
      @include position(relative, 50%, 0, auto, 0, -50%);
      width: 100%;
      height: 70px;
    }

    > a {
      @include position(absolute, 50%, 0, auto, 0, -50%);
      max-width: 120px;
      margin: 0 auto;
      @media (min-width: $tablet) {
        @include position(absolute, 50%, 0, auto, 0, -50%);
        max-width: 100px;
      }
    }
  }

  .hooper {
    padding-left: 1.5em;
    height: 100%;
  }
}
</style>
